import { Expose, Transform } from 'class-transformer';
import {
  DrupalIdentifier,
  DrupalMenuItem,
  TreeItem,
} from '@nx-icilalune/drupal-types';

export const contextLune = 'lune';
export const contextMissionControl = 'mission-control';
export const contextApps = 'apps';
export const contextMotionDesign = 'motion-design';
export const contextActualites = 'actualites';
export const contextBlog = 'blog';
export const contextClients = 'clients';
export const contextOdyssee = 'odyssee';
export const contextSolutions = 'solutions';
export const contextTerre = 'terre';
export const contextSettings = 'settings';

export type MenuItemContext =
  | typeof contextLune
  | typeof contextMissionControl
  | typeof contextApps
  | typeof contextMotionDesign
  | typeof contextActualites
  | typeof contextClients
  | typeof contextBlog
  | typeof contextOdyssee
  | typeof contextSolutions
  | typeof contextTerre
  | typeof contextSettings;

export class MainMenuItem extends DrupalMenuItem {
  public static readonly type = 'menuLinks';

  @Transform(({ obj }) => {
    if (obj.id === '41c31786-9f0f-4743-871b-8a0f9b322159') {
      return `/${obj?.attributes?.langcode}/`;
    }
    return `${obj?.attributes?.path?.url}/`;
  })
  @Expose()
  override path!: string;

  @Transform(({ obj }) => {
    return obj?.relationships?.colorId?.data?.meta?.name;
  })
  @Expose()
  color!: MenuItemContext;

  @Transform(({ obj }) => {
    return obj?.relationships?.linkNode?.data || undefined;
  })
  @Expose()
  linkNode!: DrupalIdentifier;
}

export class MainMenuTreeItem extends TreeItem<MainMenuTreeItem> {
  color!: MenuItemContext;
  linkNode!: DrupalIdentifier;
}
